import { render, staticRenderFns } from "./TwProcessGroupListItemStandard.vue?vue&type=template&id=01b9223a&scoped=true&"
import script from "./TwProcessGroupListItemStandard.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListItemStandard.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupListItemStandard.vue?vue&type=style&index=0&id=01b9223a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b9223a",
  null
  
)

export default component.exports